import { createAction, props } from '@ngrx/store';
import { IModal } from './model';

export const AddModal = '[Modal] Add'
export const RemoveModal = '[Modal] Remove '

export const addModal = createAction(
  AddModal,
  props<{ modal: IModal }>()
);
export const removeModal = createAction(
  RemoveModal
);
